import { ToEntity } from 'core/common/mappers';
import { PhotoScan, PhotoScanCoordinates } from '../entities';
import { PalmPhotoDTO, PalmCoordinatesDTO } from '../services/dto';

export class PalmDtoMapper implements ToEntity<PhotoScan, PalmPhotoDTO> {
  toEntity(dto: PalmPhotoDTO): PhotoScan {
    return {
      photoId: dto.palmistry_photo_id ?? '',
      photo: dto.palmistry_photo_template ?? '',
      coordinates: this.mapCoordinates(dto.palmistry_coordinates),
    };
  }

  private mapCoordinates(coordinates: PalmCoordinatesDTO): PhotoScanCoordinates {
    return {
      lifeLinePts: coordinates.life_line_pts,
      heartLinePts: coordinates.heart_line_pts,
      marriageLinePts: coordinates.marriage_line_pts,
      headLinePts: coordinates.head_line_pts,
      moneyLinePts: coordinates.fate_line_pts,
      thumbFingerTip: coordinates.thumb_finger_tip,
      indexFingerTip: coordinates.index_finger_tip,
      middleFingerTip: coordinates.middle_finger_tip,
      ringFingerTip: coordinates.ring_finger_tip,
      pinkyFingerTip: coordinates.pinky_finger_tip,
    };
  }
}
